import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import {MaintenanceService} from './services/maintenance.service';

@Injectable()
export class MaintenanceGuard implements CanActivate {
  constructor(private maintenanceService: MaintenanceService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.maintenanceService.getStatus()
      .map(status => {
        if (status.enabled) {
          this.router.navigate(['/maintenance']);
          return false;
        }
        return true;
      })
      .catch(() => Observable.of(true));
  }
}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/MaintenanceGuard.ts